import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import LibraryService from '../../../core/service'

// getHeaderSavedPortfolioDetail
export const getHeaderSavedPortfolioDetail = createAsyncThunk(
  'library/savedPortfoliosDetails/getHeaderSavedPortfolioDetail',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getHeaderSavedPortfolioDetail(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//data search company
export const getSearchCompanyInPortfolioDetails = createAsyncThunk(
  'library/savedPortfoliosDetails/getSearchCompanyInPortfolioDetails',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.getSearchCompanyInPortfolioDetails(
        params,
      )

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//change status Alert company
export const putUpdateAlertCompany = createAsyncThunk(
  'library/savedPortfoliosDetails/putUpdateAlertCompany',
  async (params) => LibraryService.putUpdateAlertCompany(params),
)

//delete company
export const delDeleteCompany = createAsyncThunk(
  'library/savedPortfoliosDetails/delDeleteCompany',
  async (params) => LibraryService.delDeleteCompany(params),
)

//downloadDetailPortfolio
export const downloadSavedPortfolio = createAsyncThunk(
  'library/savedPortfoliosDetails/downloadPortfolioDetail',
  async (params) => {
    try {
      const response = await LibraryService.downloadPortfolioDetail(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

//download template  downloadTemplate
export const downloadTemplate = createAsyncThunk(
  'library/savedPortfoliosDetails/downloadTemplate',
  async (params) => {
    try {
      const response = await LibraryService.downloadTemplate(params)
      handleExport(response.data, response.filename)
    } catch (error) {
      console.log(error)
    }
  },
)

//add new company postAddNewCompany
export const postAddNewCompany = createAsyncThunk(
  'library/savedPortfoliosDetails/postAddNewCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postAddNewCompany(params)

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//post import excel
export const postImportExcel = createAsyncThunk(
  'library/savedPortfoliosDetails/postImportExcel',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postImportExcel(params)

      return res.success ? res.data : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//postMoveOrCopyCompany
export const postMoveOrCopyCompany = createAsyncThunk(
  'library/savedPortfoliosDetails/postMoveOrCopyCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postMoveOrCopyCompany(params)

      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//postCopyCompany
export const postCopyCompany = createAsyncThunk(
  'library/savedPortfoliosDetails/postCopyCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await LibraryService.postCopyCompany(params)
      return res.success ? res : rejectWithValue({ loading: false })
    } catch (error) {
      return rejectWithValue({ loading: axios.isCancel(error) })
    }
  },
)

//getAllIdCompanyInPortfolio
export const getAllIdCompanyInPortfolio = createAsyncThunk(
  'library/savedPortfoliosDetails/getAllIdCompanyInPortfolio',
  async (params, { rejectWithValue }) => {
    try {
      const response = await LibraryService.getAllIdCompanyInPortfolio(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
